export default {
    locale: "English",
    mainSectionText1: "We make Quranic apps & other software",

    tajwidTagline1: "A Scholar-Certified App",
    tajwidTagline1Row2: "for Learning",
    tajwidTagline1Bold: "Tajweed Easily,",
    tajwidTagline1AfterBold: "Used by Millions Worldwide",

    poin1Tajwid: "Effective",
    poin2Tajwid: "High Quality",
    poin3Tajwid: "Efficient",
    poin4Tajwid: "Comprehensive",
    poin5Tajwid: "Verified",

    learnMoreTajwid: "Learn More",

    qtvTagline1: "The best",
    qtvTagline1Row2: "Mushaf Quran",
    qtvTagline1Bold: "app for",
    qtvTagline1AfterBold: "Smart TV platforms",
    qtvTagline1Row3: "إِنْ شَاءَ ٱللَّٰهُ !",

    learnMoreQtv: "Learn More",

    poin1Qtv: "Specially made for TV",
    poin2Qtv: "Offline-able",
    poin3Qtv: "Optimized for reading and displaying",
    poin4Qtv: "Easy to Use",
    poin5Qtv: "Easy to Use",
    poin6Qtv: "Feature-rich",

    textProductTafsir1: "One app for all your needs to master your understanding of Quran tafsir",
    textProductTafsir2: "The excellences will makes you understanding Quran tafsir",

    tafsirTagline1: "High quality apps",
    tafsirTagline1Row2: "for learning",
    tafsirTagline1Bold: "to understand",
    tafsirTagline1AfterBold: "Al-Qur'an",

    poin1Tafsir: "Various Tafsirs",
    poin2Tafsir: "User Friendly",
    poin3Tafsir: "Smart Search",
    poin4Tafsir: "High Quality",
    poin5Tafsir: "Trustworthy Sources",
    poin6Tafsir: "Anytime, Anywhere",

    learnMoreTafsir: "Learn More",

    impactUsers: "USERS",
    impactUsers2: "english",
    impactCountries: "COUNTRIES",
    impactMinutesUsage: "MINUTES OF USAGE",

    textAward1: "Awards",
    textAward2: "Awardee",
    textAward3: "1st Winner",
    textAward4: "Most Innovative Apps Globally",
    textAward5: "Ma'a Impact Prize by Global Sadaqah",

    textPublishedBy1: "Published by",
    textPublishedBy2: "and many more...",

    textPartners1: "Partners",

    siteMapCol2Row1: "Services",
    siteMapCol2Row2: "Software Development for You",
    siteMapCol2Row3: "Learn with Quran Teacher",
    siteMapCol2Row4: "About Quran Mushaf",
    siteMapCol2Row5: "Jariyah Opportunity",
    siteMapCol2Row6: "Posts",
    siteMapCol2Row7: "Advertise with Us",

    siteMapCol3Row1: "Our Partners",
    siteMapCol3Row2: "BAZNAS",
    siteMapCol3Row3: "BEKRAF",
    siteMapCol3Row4: "Code Margonda",
    siteMapCol3Row5: "FUSI Foundation",

    siteMapCol4Row1: "Products",
    siteMapCol4Row2: "Learn Quran Tajwid",
    siteMapCol4Row3: "Learn Quran Tafsir",
    siteMapCol4Row4: "Quran Mushaf Apps",
    siteMapCol4Row5: "LQTafsir Android",
    siteMapCol4Row5B: "LQTafsir iOS",
    siteMapCol4Row6: "Quran Mushaf Android TV",
    siteMapCol4Row7: "Quran Mushaf Fire TV",
    siteMapCol4Row8: "Quran Mushaf Samsung TV",

    siteMapCol5Row1: "Official Accounts",

    textCopyright1: "Copyright",

    textService: "We also provide software development services",
  };